import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_RESPONSE,
  ADD_CATEGORY_REQUEST,
  EDIT_CATEGORY_REQUEST,
  PATCH_CATEGORY_TOGGLE_REQUEST,
  GET_CATEGORY_DETAILS_REQUEST,
  GET_CATEGORY_DETAILS_RESPONSE,
  DELETE_CATEGORY_REQUEST,
} from "./types";

// list
export const getCategoriesRequest = (payload) => ({
  type: GET_CATEGORIES_REQUEST,
  payload,
});

export const getCategoriesResponse = (payload) => ({
  type: GET_CATEGORIES_RESPONSE,
  payload,
  });

// add
export const addCategoryRequest = (payload) => ({
  type: ADD_CATEGORY_REQUEST,
  payload,
});

// edit
export const editCategoryRequest = (payload) => ({
  type: EDIT_CATEGORY_REQUEST,
  payload,
});

// patch toggle
export const patchCategoryToggleRequest = (payload) => ({
  type: PATCH_CATEGORY_TOGGLE_REQUEST,
  payload,
});

// get by id (view)
export const getCategoryDetailsRequest = (payload) => ({
  type: GET_CATEGORY_DETAILS_REQUEST,
  payload,
});

export const getCategoryDetailsResponse = (payload) => ({
  type: GET_CATEGORY_DETAILS_RESPONSE,
  payload,
});

export const deleteCategoryRequest = (payload) => ({
  type: DELETE_CATEGORY_REQUEST,
  payload,
});
